var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{staticClass:"overlayfull",attrs:{"show":_vm.isLoading}},[_c('iframe',{staticClass:"fullscreen",attrs:{"src":_vm.src,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }